import React from 'react'
import { Outlet } from 'react-router-dom'
import { Layout } from 'antd'
import { Helmet } from 'react-helmet-async'
import TopBar from '../top_bar'

const { Header } = Layout

const SharedLayout = () => {
  return (
    <>
      <Helmet titleTemplate={`Meridian | %s`} title="Welcome" />

      <Layout
        style={{
          height: '100dvh',
          overflow: 'hidden',
        }}
      >
        <Header
          style={{
            paddingInline: 0,
            background: 'white',
            color: 'rgba(0, 0, 0, 0.88)',
          }}
        >
          <TopBar />
        </Header>

        <Outlet />
      </Layout>
    </>
  )
}

export default SharedLayout
